export default __webpack_public_path__ + "media/services_logos.ba040.png";